import { render, staticRenderFns } from "./createRole.vue?vue&type=template&id=1fad9346&scoped=true&"
import script from "./createRole.vue?vue&type=script&lang=js&"
export * from "./createRole.vue?vue&type=script&lang=js&"
import style0 from "./createRole.vue?vue&type=style&index=0&id=1fad9346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fad9346",
  null
  
)

export default component.exports